import React from 'react'
import styled from 'styled-components'
import DefaultLayout from '../components/DefaultLayout'

const Offer = styled.div`
    border-radius: 0 0 3.75rem 3.75rem;
    height: 100vh;
    background-size: cover;
    background-image: url(https://cdn1.ozone.ru/s3/seller-promo-events/ui/images/main/c1980/background.jpg);
    .container {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    h2 {
        line-height: 100%;
        margin-bottom: 30px;
        font-size: 90px;
        color: #fff;
        max-width: 65%;
        font-weight: 600;
    }
    p {
        color: #fff;
        font-size: 23px;
        margin-bottom: 32px;
        max-width: 65%;
        line-height: 140%;
        font-weight: 300;
    }
    button {
        font-size: 21px;
        color: #000;
        max-height: 64px;
        border-radius: 0.5rem;
        height: 64px;
        background: #fff;
        width: 235px;
        font-weight: 600;
    }
`

const Info = styled.div`
    margin: 50px 0;
    .list {
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        grid-template-rows: 15.625rem;
        grid-gap: 24px;
    }
    .card {
        padding: 3.125rem 2.5rem 0 1.25rem;
        transition: 0.25s all ease;
        border-radius: 1.25rem;
        cursor: pointer;
        &:hover {
            background: #fff;
            box-shadow: 0 47px 304px rgb(0 26 52 / 4%),
                0 30.463px 178.037px rgb(0 26 52 / 3%),
                0 18.1037px 96.8296px rgb(0 26 52 / 2%),
                0 9.4px 49.4px rgb(0 26 52 / 2%),
                0 3.82963px 24.7704px rgb(0 26 52 / 2%),
                0 0.87037px 11.963px rgb(0 26 52 / 1%);
            padding-top: 2.5rem !important;
        }
    }
    p {
        font-size: 18px;
        font-weight: 300;
    }
    h2 {
        font-size: 41px;
        margin-bottom: 15px;
    }
`

const Support = styled.div`
    background: #eff3f6;
    padding: 141px 0;
    .container {
        display: grid;
        grid-template-columns: 1fr 470px;
        grid-gap: 200px;
    }
    h2 {
        font-size: 51px;
        line-height: 1;
        font-weight: 600;
        margin-bottom: 30px;
    }
    .card {
        position: relative;
        display: flex;
        width: 100%;
        padding-left: 60px;
        &:nth-child(n + 2) {
            margin-top: 55px;
        }
    }
    svg {
        width: 41px;
        position: absolute;
        top: 0;
        left: 0;
    }
    p {
        font-weight: 500;
        color: #000;
        font-size: 23px;
        line-height: 1.15;
    }
    span {
        color: #005bff;
    }
    img {
        width: 100%;
    }
    button {
        background: #000;
        margin-top: 4.5rem;
        font-size: 21px;
        border-radius: 0.5rem;
        padding: 0 28px;
        height: 64px;
        color: #fff;
        font-weight: 600;
        border: none;
    }
`

const Join = styled.div`
    margin-bottom: 30px;
    height: 335px;
    padding: 83px;
    background-image: url(https://cdn1.ozone.ru/s3/seller-promo-events/static/home/c1980/join-desk.jpg);
    .container {
        display: flex;
        flex-direction: column;
        padding-top: 0 !important;
        align-items: flex-end;
    }
    .cont {
        width: 500px;
        line-height: 1;
        color: #fff;
        margin-right: 43px;
    }
    h2 {
        font-size: 36px;
        white-space: wrap;
        margin-bottom: 40px;
    }
    button {
        font-size: 16px;
        color: #000;
        max-height: 64px;
        border-radius: 0.5rem;
        height: 64px;
        background: #fff;
        width: 235px;
        font-weight: 600;
    }
`

const Table = styled.div`
    background-color: #101117;
    padding: 100px 0;

    h1 {
        font-size: 51px;
        color: #fff;
        margin-bottom: 30px;
    }
    p.main {
        font-weight: 300;
        font-size: 18px;
        margin-bottom: 55px;
        color: #fff;
        max-width: 70%;
    }

    .head {
        border-radius: 0 0 1rem 1rem;
        background-color: #eff3f6;
        position: relative;
        top: 2rem;
        height: 66px;
        align-items: center;
        display: grid;
        justify-content: space-between;
        grid-template-columns: repeat(4, 235px);
        p {
            padding-left: 21px;
            color: #000;
            font-weight: 600;
            font-size: 27px;
        }
    }
    .body {
        padding-top: 50px;
        border-radius: 0 0 1rem 1rem;
        padding-bottom: 20px;
        background: #15171f;
    }
    .table_list {
        display: grid;
        justify-content: space-between;
        grid-template-columns: repeat(4, 235px);
    }
    .card {
        padding: 0 12px 0 18px;
        &:not(:first-child) {
            border-left: 1px dashed #96a3ae;
        }
        p.info {
            font-size: 14px;
            color: #fff;
        }
        h5.info {
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 15px;
            color: #fff;
        }
    }
    .card.where {
        display: flex;
        align-items: center;
        p {
            margin-left: 15px;
            font-size: 14.5px;
            color: #fff;
        }
    }
    h4.subtitle {
        padding-left: 35px;
        font-size: 22px;
        font-weight: 600;
        margin-bottom: 27px;
        color: #fff;
    }
`

const Seller = () => {
    return (
        <DefaultLayout>
            <Offer>
                <div className="container">
                    <h2>Любому бизнесу найдётся место на Ozon</h2>
                    <p>
                        Ozon — это прямой доступ к миллионам клиентов по всей
                        России. Вы больше не ограничены размером вашего бизнеса
                        и конкуренцией с крупными игроками. Предлагайте
                        покупателям хорошие товары по выгодным ценам, а мы
                        позаботимся о сервисе и доставке.
                    </p>
                    <button>Начать продавать</button>
                </div>
            </Offer>
            <Info>
                <div className="container">
                    <div className="list">
                        <div className="card">
                            <h2>23 года</h2>
                            <p>на рынке электронной торговли</p>
                        </div>
                        <div className="card">
                            <h2>>48 млн</h2>
                            <p>ежемесячной аудитории</p>
                        </div>
                        <div className="card">
                            <h2>>19 000</h2>
                            <p>точек выдачи заказов</p>
                        </div>
                        <div className="card">
                            <h2>80%</h2>
                            <p>продаж приходится на регионы</p>
                        </div>
                        <div className="card">
                            <h2>>20</h2>
                            <p>категорий товаров - от электроники до мебели</p>
                        </div>
                    </div>
                </div>
            </Info>
            <Support>
                <div className="container">
                    <div className="left">
                        <h2>Поддержим на старте</h2>
                        <div className="card">
                            <svg
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="support__icon"
                                data-v-5a040e9a=""
                            >
                                <path
                                    d="M24.7071 13.2929C25.0976 13.6834 25.0976 14.3166 24.7071 14.7071L16.7071 22.7071C16.3166 23.0976 15.6834 23.0976 15.2929 22.7071L11.2929 18.7071C10.9024 18.3166 10.9024 17.6834 11.2929 17.2929C11.6834 16.9024 12.3166 16.9024 12.7071 17.2929L16 20.5858L23.2929 13.2929C23.6834 12.9024 24.3166 12.9024 24.7071 13.2929Z"
                                    fill="#001A34"
                                    data-v-5a040e9a=""
                                ></path>{' '}
                                <rect
                                    x="1"
                                    y="1"
                                    width="34"
                                    height="34"
                                    rx="17"
                                    stroke="#001A34"
                                    strokeWidth="2"
                                    data-v-5a040e9a=""
                                ></rect>
                            </svg>
                            <p>
                                Помощь с подключением к площадке —
                                <span>сертифицированные партнёры</span> помогут
                                с выходом на маркетплейс
                            </p>
                        </div>
                        <div className="card">
                            <svg
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="support__icon"
                                data-v-5a040e9a=""
                            >
                                <path
                                    d="M24.7071 13.2929C25.0976 13.6834 25.0976 14.3166 24.7071 14.7071L16.7071 22.7071C16.3166 23.0976 15.6834 23.0976 15.2929 22.7071L11.2929 18.7071C10.9024 18.3166 10.9024 17.6834 11.2929 17.2929C11.6834 16.9024 12.3166 16.9024 12.7071 17.2929L16 20.5858L23.2929 13.2929C23.6834 12.9024 24.3166 12.9024 24.7071 13.2929Z"
                                    fill="#001A34"
                                    data-v-5a040e9a=""
                                ></path>{' '}
                                <rect
                                    x="1"
                                    y="1"
                                    width="34"
                                    height="34"
                                    rx="17"
                                    stroke="#001A34"
                                    strokeWidth="2"
                                    data-v-5a040e9a=""
                                ></rect>
                            </svg>
                            <p>
                                Бесплатное размещение на складе Ozon в первый
                                месяц — для любых товаров
                            </p>
                        </div>
                        <div className="card">
                            <svg
                                width="36"
                                height="36"
                                viewBox="0 0 36 36"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="support__icon"
                                data-v-5a040e9a=""
                            >
                                <path
                                    d="M24.7071 13.2929C25.0976 13.6834 25.0976 14.3166 24.7071 14.7071L16.7071 22.7071C16.3166 23.0976 15.6834 23.0976 15.2929 22.7071L11.2929 18.7071C10.9024 18.3166 10.9024 17.6834 11.2929 17.2929C11.6834 16.9024 12.3166 16.9024 12.7071 17.2929L16 20.5858L23.2929 13.2929C23.6834 12.9024 24.3166 12.9024 24.7071 13.2929Z"
                                    fill="#001A34"
                                    data-v-5a040e9a=""
                                ></path>{' '}
                                <rect
                                    x="1"
                                    y="1"
                                    width="34"
                                    height="34"
                                    rx="17"
                                    stroke="#001A34"
                                    strokeWidth="2"
                                    data-v-5a040e9a=""
                                ></rect>
                            </svg>
                            <p>
                                Возможность получить финансирование — выгодные
                                условия кредитования на платформе{' '}
                                <span>Ozon Invest</span>
                            </p>
                        </div>
                        <button>Начать продавать</button>
                    </div>
                    <img
                        src="https://cdn1.ozone.ru/s3/seller-promo-events/static/home/support-desk.jpeg"
                        alt=""
                    />
                </div>
            </Support>
            <Table>
                <div className="container">
                    <h1>Схемы работы на ваш выбор</h1>
                    <p className="main">
                        Предлагаем разные варианты логистики, чтобы вы могли
                        быстро подстроить работу с маркетплейсом под особенности
                        своего бизнеса и ассортиментa
                    </p>
                    <div className="head">
                        <p>FBO</p>
                        <p>FBS</p>
                        <p>RFBS</p>
                        <p>Express</p>
                    </div>
                    <div className="body">
                        <div
                            className="table_list"
                            style={{ marginBottom: '20px' }}
                        >
                            <div className="card">
                                <h5 className="info">Склад и доставка Ozon</h5>
                                <p className="info">
                                    Размещение на складе, сборка и доставка
                                    товаров — на нашей стороне. Вам остаётся
                                    лишь передать нам товары.
                                </p>
                            </div>
                            <div className="card">
                                <h5 className="info">
                                    Склад – ваш, доставка – Ozon
                                </h5>
                                <p className="info">
                                    Размещаете товары на своём складе, собираете
                                    заказы и передаёте готовые упаковки в Ozon
                                    для доставки покупателям.
                                </p>
                            </div>
                            <div className="card">
                                <h5 className="info">
                                    Склад и доставка – ваши
                                </h5>
                                <p className="info">
                                    Мы выступаем торговой площадкой, а
                                    размещение на складе, сборка и доставка
                                    заказов — на вашей стороне.
                                </p>
                            </div>
                            <div className="card">
                                <h5 className="info">
                                    Склад и доставка – ваши
                                </h5>
                                <p className="info">
                                    Собираете заказы не дольше часа, передаёте
                                    курьеру для быстрой доставки в пределах
                                    города.
                                </p>
                            </div>
                        </div>
                        <h4 className="subtitle">Где размещается</h4>
                        <div
                            className="table_list"
                            style={{ marginBottom: '20px' }}
                        >
                            <div className="card where">
                                <img
                                    src="https://cdn1.ozone.ru/s3/seller-promo-events/static/home/schemes/ozon-icon.svg"
                                    alt=""
                                />
                                <p className="where">Ozon</p>
                            </div>
                            <div className="card where">
                                <img
                                    src="https://cdn1.ozone.ru/s3/seller-promo-events/static/home/schemes/warehouse-icon.svg"
                                    alt=""
                                />
                                <p className="where">Склад продавца</p>
                            </div>
                            <div className="card where">
                                <img
                                    src="https://cdn1.ozone.ru/s3/seller-promo-events/static/home/schemes/warehouse-icon.svg"
                                    alt=""
                                />
                                <p className="where">Склад продавца</p>
                            </div>
                            <div className="card where">
                                <img
                                    src="https://cdn1.ozone.ru/s3/seller-promo-events/static/home/schemes/warehouse-icon.svg"
                                    alt=""
                                />
                                <p className="where">Склад продавца</p>
                            </div>
                        </div>
                        <h4 className="subtitle">Кто упаковывает заказ</h4>
                        <div className="table_list">
                            <div className="card where">
                                <img
                                    src="https://cdn1.ozone.ru/s3/seller-promo-events/static/home/schemes/ozon-icon.svg"
                                    alt=""
                                />
                                <p className="where">Ozon</p>
                            </div>
                            <div className="card where">
                                <img
                                    src="https://cdn1.ozone.ru/s3/seller-promo-events/static/home/schemes/warehouse-icon.svg"
                                    alt=""
                                />
                                <p className="where">Продавец</p>
                            </div>
                            <div className="card where">
                                <img
                                    src="https://cdn1.ozone.ru/s3/seller-promo-events/static/home/schemes/warehouse-icon.svg"
                                    alt=""
                                />
                                <p className="where">Продавец</p>
                            </div>
                            <div className="card where">
                                <img
                                    src="https://cdn1.ozone.ru/s3/seller-promo-events/static/home/schemes/warehouse-icon.svg"
                                    alt=""
                                />
                                <p className="where">Продавец</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Table>
            <Join>
                <div className="container">
                    <div className="cont">
                        <h2>Присоединяйтесь, будем расти вместе</h2>
                        <button>Начать продавать</button>
                    </div>
                </div>
            </Join>
        </DefaultLayout>
    )
}

export default Seller
